import { fontSize, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem, stack } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
import { commonHeading } from "./common.styles";
var spacing = theme.spacing,
  text = theme.text;
var PANEL_OFFSET = spacing.lg;
export var heading = /*#__PURE__*/css(["", " margin:", ";", ""], commonHeading, stack(spacing.md), mediaQuery({
  min: minBreakpoints.M
}, css(["text-align:center;"])));
export var copy = /*#__PURE__*/css(["", " margin:", ";", " ", ";"], fontSize(text.BODY.MD), stack(spacing.xl + PANEL_OFFSET), mediaQuery({
  min: minBreakpoints.M
}, css(["text-align:center;"])), mediaQuery({
  min: minBreakpoints.L
}, css(["", ""], fontSize(text.HEADING.XS))));
export var partners = /*#__PURE__*/css(["background-color:var(--neutral-black-10);padding-bottom:", ";"], pxToRem(spacing.xl));